import React from "react";
import ModalWrapper from "../modals/ModalWrapper";
import PdfViewer from "./PdfViewer";

/**
 * Modal that shows a PDF viewer over the current page.
 *
 * @param {Object} props - Component props.
 * @param {boolean} props.isOpen - Whether the modal is open.
 * @param {Function} props.onClose - Close handler.
 * @param {string} props.pdfUrl - Absolute URL to the PDF endpoint.
 * @param {boolean} [props.authenticated=true] - Fetch PDF with session credentials.
 * @param {string} [props.title="PDF"] - Viewer title.
 * @param {string} [props.subtitle] - Optional note shown under the title.
 * @returns {JSX.Element|null}
 */
const PdfViewerModal = ({
  isOpen,
  onClose,
  pdfUrl,
  authenticated = true,
  title = "PDF",
  subtitle,
}) => {
  return (
    <ModalWrapper
      isOpen={isOpen}
      onClose={onClose}
      maxWidth={900}
      className="bg-white rounded-lg shadow-lg relative w-full max-h-[92vh] overflow-y-auto p-3"
      overlayClassName="z-50"
    >
      {/* Only mount while open so authenticated blob fetch runs on each open */}
      {isOpen ? (
        <PdfViewer
          pdfUrl={pdfUrl}
          authenticated={authenticated}
          title={title}
          subtitle={subtitle}
          showHeading={true}
        />
      ) : null}
    </ModalWrapper>
  );
};

export default PdfViewerModal;
